import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { enableMapSet } from 'immer'

export type FileState = Map<string, any>

export const fileInitialState: FileState = new Map()

export namespace fileNS {
	export type setKnowledgeFile = PayloadAction<{ filename: string; file: File }>
}

enableMapSet()

export const fileSlice = createSlice({
	name: 'file',
	initialState: fileInitialState,
	reducers: {
		setKnowledgeFile: (state, action: fileNS.setKnowledgeFile) => {
			const { file, filename } = action.payload
			state.set(filename, file)
		},
	},
})
